import {
	ADMINGETFEEMAPPING_SUCCESS,
	ADMINGETFEEMAPPING_FAILED,
	RESET_ADMINGETFEEMAPPING,
	LOADING_ADMINGETFEEMAPPING,
	NETWORK_ERROR_ADMINGETFEEMAPPING
} from "../types/index";
import { adminServices } from "../../config/axios";

const resetAdminGetFeeMapping = () => {
	return { type: RESET_ADMINGETFEEMAPPING };
};

const adminGetFeeMapping = (userData, authTokenIs) => async (dispatch) => {
	dispatch({ type: LOADING_ADMINGETFEEMAPPING });
	await adminServices
		.post("getFeeMappingList", userData, { headers: { AuthToken: authTokenIs } })
		.then((res) => {
			switch (res.data.status) {
				case "success":
					dispatch(adminGetFeeMappingsuccess(res.data));
					break;
				default:
					dispatch(adminGetFeeMappingFailed(res.data));
					break;
			}
		})
		.catch((err) => {
			dispatch({
				type: NETWORK_ERROR_ADMINGETFEEMAPPING,
				payload: err
			});
		});
};
function adminGetFeeMappingsuccess(data) {
	return {
		type: ADMINGETFEEMAPPING_SUCCESS,
		payload: data
	};
}
function adminGetFeeMappingFailed(data) {
	return {
		type: ADMINGETFEEMAPPING_FAILED,
		payload: data
	};
}

export { resetAdminGetFeeMapping, adminGetFeeMapping };
